import TeacherPriceForm from './TeacherPriceForm';

export default TeacherPriceForm;
